import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import axios from 'src/app/Service/axios';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-tanker-supply-details',
  templateUrl: './tanker-supply-details.component.html',
  styleUrls: ['./tanker-supply-details.component.css']
})
export class TankerSupplyDetailsComponent implements OnInit {

  supplyDetails: any = [];
  search: any = [];

  searchForm: FormGroup = this.FormBuilder.group({
    iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
    strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
    strFullName: new FormControl(''),
    strUnitID: new FormControl(''),
    feedingValue: new FormControl(''),
    strSDate: new FormControl(''),
    strEDate: new FormControl(''),
  })

  constructor(
    private otherService: OtherService,
    private FormBuilder: FormBuilder,
    private ActivatedRoute: ActivatedRoute,
    private router: Router,
    private gurdService: GurdServiceService,
    private Notification: NotificationService
  ) { }

  ngOnInit(): void {

    const id = this.ActivatedRoute.snapshot.paramMap.get('id');
    const queryParams = new URLSearchParams(window.location.search);
    const startDate = queryParams.get('start');
    const endDate = queryParams.get('end');
    const feedingValue = queryParams.get('feedingValue');

    this.searchForm.patchValue({
      strUnitID: id,
      strSDate: startDate,
      strEDate: endDate,
      feedingValue: feedingValue,
    });

    this.fetchSupplyDetails();

  }

  fetchSupplyDetails = async () => {
    let model = this.searchForm.value;
    this.otherService.Showspinner();
    let res = JSON.parse((await axios.post(`Tanker_Report_Feeding_Detail`, this.otherService.stringNumberToNumber(model))).data.toString());
    this.otherService.nonespinner();

    if (res.ISSessionExpired == true) {
      this.Notification.showError('لطفا وارد سیستم شوید');
      this.otherService.removeLocalStorage();
      this.router.navigate(['login'], { queryParams: { error: 'x12z110' } });
      return;

    }

    if (res.iResult == 0) {
      return this.Notification.showError(res.strError);
    }

    this.supplyDetails = this.search = res;

    this.searchForm.patchValue({
      strFullName: res[0].strFullName
    });

  }

  filterResult(strValue: string) {
    if (strValue.length > 1) {
      this.supplyDetails = this.search.filter((el: any) => {
        return el.strMaterialType_strComment.includes(strValue) ||
          el.strTitle?.includes(strValue) ||
          el?.strDate.includes(strValue)
      })
    }
    else if (strValue == '') {
      this.supplyDetails = this.search;
    }
  }

  openMap(item: any) {
    this.openMapInNewTab([item]);
  }

  showAllOnMap() {
    if (!this.supplyDetails.length) {
      return this.Notification.showError('نتیجه ایی یافت نشد!');
    }

    this.openMapInNewTab(this.supplyDetails);
  }

  private openMapInNewTab(data: any[]) {
    window.localStorage.removeItem('supplyDetails');

    const encryptedDetails = this.gurdService.encrypt(JSON.stringify(data));
    window.localStorage.setItem('supplyDetails', encryptedDetails);

    const urlTree = this.router.createUrlTree(['tanker', 'show-all-in-map']);
    const serializedUrl = this.router.serializeUrl(urlTree);

    window.open(serializedUrl, '_blank');
  }

  exportExcel() {
    setTimeout(() => {
      let element = document.getElementById('Export_Excel');
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
      XLSX.writeFile(wb, 'جزئیات گزارش شرح تامین.xlsx');
    }, 200);
  }

  getRowClass(item: any): string {
    if (item.iGeoFence === 0) {
      if (item.fFeedingValue > 1000) {
        return 'row-orange';
      } else if (item.fFeedingValue > 500 && item.fFeedingValue <= 1000) {
        return 'row-brown';
      } else {
        return 'row-yellow';
      }
    }
    return '';
  }


}
